export default {
  googlePlay: {
    en: 'Get in Google Play',
  },
  appleStore: {
    en: 'Get in App Store',
  },
}
